import React from "react";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const AddDirectPayForm = ({ isEdit, documentId }) => {
  const myForm = new BCFormController({}, { 
    recordId: documentId, 
    initIsDisabled: isEdit, 
    submitMethod: "POST", 
    payloadDataType: "FormData",
    submitSuffix: "document/direct-pay-form" 
  });

  myForm.addCenteredGroup([myForm.getFileField("Attachment", { name: "assetFile", required: true })]);
  return <LmsFormGenerator myForm={myForm} actions={[{ text: "Save and Continue", action: "save" }, "close"]}/>;
};

export const DirectPayTable = () => {
  return <LmsTable
    actionButtons={["add", "remove", "export"]}
    apiSuffix="document/direct-pay-forms"
    deleteSuffix="document/direct-pay-forms"
    skipClick
    columnLabelsDictionary={{ description: "Result" }}
  />;
};

const LmsUploadDirectPayForm = ({ ...props }) => {
  const { params = {}, history } = props;
  const allowedActions = ["add"];
  const allowedSubpages = [];
  const { isAdd, isEdit, isMainPage, isActionAllowed, id: documentId } = useParseRouteActions(params, allowedActions, allowedSubpages);

  if (!isActionAllowed) {
    history.goBack();
  }

  return <React.Fragment>
    {isMainPage && <DirectPayTable />}
    {isAdd && <AddDirectPayForm isEdit={isEdit} documentId={documentId} />}
  </React.Fragment>;
};

export default LmsUploadDirectPayForm;